<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">合作商管理</div>
          <span class="m-title-s">对合作商进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-search-wrap">
        <el-form :inline="true" :model="searchForm" ref="searchForm">
          <el-form-item label="电话:">
            <el-input type="text" size="medium" v-model="searchForm.phone"  placeholder="搜索电话" />
          </el-form-item>
          <el-form-item label="合作商姓名:">
            <el-input type="text" size="medium" v-model="searchForm.cooperatorName"  placeholder="搜索合作商姓名" />
          </el-form-item>
          <el-form-item style="margin-left: 30px;">
            <el-button type="primary" @click="listData()">搜索</el-button>
            <el-button type="primary" plain @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>市合作商列表
            <span style="margin-left: 20px; color: #ff4d51;font-size: 14px">(创建合作商后，在列表中《服务地区》为合作商分配合作地区，《绑定app》绑定初始用户)</span>
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup('add')" type="primary" size="medium">新增合作商</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" row-key="id" border size="small">
          <el-table-column prop="cooperatorName" label="负责人名称" width=""></el-table-column>
          <el-table-column prop="phone" label="负责人电话" width="130" align="center"></el-table-column>
          <el-table-column prop="companyName" label="企业名称" width=""></el-table-column>
          <el-table-column prop="companyCode" label="统一信用代码" width=""></el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="60">
            <template slot-scope="scope">
              <span v-text="scope.row.sex === '1' ? '男' : '女'" :class="scope.row.sex === '1' ? 'm-tips-blue' : 'm-tips-red'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" width="80" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="90" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="90" align="center"></el-table-column>
          <el-table-column prop="sex" label="登录状态" align="center" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.loginFlag === '1'" size="small" type="success">开启</el-tag>
              <el-tag v-if="scope.row.loginFlag === '0'" size="small" type="info">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="服务地区" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openCity(scope.row)" plain>服务地区</el-button>
            </template>
          </el-table-column>
          <el-table-column label="绑定" width="110" align="center">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" @click="openAppBinding(scope.row.id)" plain>绑定app</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <el-form :model="form" :rules="rules" ref="form" label-width="125px">
          <el-form-item label="上级合作商: " prop="provinceCooperatorId">
            <el-input v-model="form.provinceCooperatorName" :id="form.provinceCooperatorId" placeholder="点击右侧按钮" disabled>
              <el-button type="primary" slot="append"  @click="tree = true">选择上级</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="企业名称: " prop="companyName">
            <el-input v-model="form.companyName" placeholder="输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="统一信用代码: " prop="companyCode">
            <el-input v-model="form.companyCode" placeholder="输入统一信用代码"></el-input>
          </el-form-item>
          <el-form-item label="负责人姓名: " prop="cooperatorName">
            <el-input v-model="form.cooperatorName" placeholder="输入负责人姓名"></el-input>
          </el-form-item>
          <el-form-item label="负责人电话: " prop="phone">
            <el-input v-model="form.phone" placeholder="输入负责人电话"></el-input>
          </el-form-item>
          <el-form-item label="负责人年龄: " prop="age">
            <el-input v-model="form.age" placeholder="输入负责人年龄"></el-input>
          </el-form-item>
          <el-form-item label="负责人性别: " prop="sex">
            <el-select v-model="form.sex" placeholder="请选择">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="初始密码: " prop="password">
            <el-input v-model="form.password" placeholder="输入初始密码"></el-input>
          </el-form-item>
          <el-form-item label="备注说明: " prop="remarks">
            <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
          </el-form-item>
          <el-form-item label="登录状态: " prop="loginFlagStatus">
            <el-switch v-model="loginFlagStatus" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择所属省级id -->
    <el-dialog width="600px" title="请选择上级菜单" :visible.sync="tree" center append-to-body>
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <el-tree
        class="filter-tree"
        :data="proviceCoopList"
        node-key="id"
        default-expand-all
        :filter-node-method="filterNode"
        ref="tree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" :name="node.label" :value="data.id" @click="selectMenu">选择</el-button>
            </span>
          </span>
      </el-tree>
    </el-dialog>
    <!-- 市服务区弹窗 -->
    <el-dialog title="市级服务区域" :visible.sync="openCityState" @close='closeCityDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-coop-container" v-loading="formLoading">
        <el-form :model="cityForm" ref="cityForm" label-width="100px">
          <el-form-item label="ID" prop="id" hidden>
            <el-input v-model="cityForm.id" type="hidden"></el-input>
          </el-form-item>
          <el-form-item label="服务区域: " prop="cityCountySimple">
            <el-select v-model="cityForm.cityListVal" filterable multiple placeholder="请选择" @change="cityChange" style="width: 100%">
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.proviceSimple + '-' + item.cityCountySimple"
                :value="item.cityCountyId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openCityState = false">取 消</el-button>
          <el-button type="primary" @click="submitCity()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 绑定app初始用户弹窗 -->
    <el-dialog title="绑定app初始用户" :visible.sync="appBindingState" @close="closeAppFormDialog" width="600px" center append-to-body :close-on-click-modal="false">
      <div class="m-open-coop-container" v-loading="formLoading">
        <el-form label-width="100px">
          <el-form-item label="app用户电话: " prop="appUserPhone">
            <el-input v-model="appForm.appUserPhone" :id="appForm.appUserPhone" placeholder="输入app用户手机号"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="appBindingState = false">取 消</el-button>
          <el-button type="primary" @click="submitUserPhone()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CooperatorManage',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      list: [],
      openCityState: false,
      openProviceState: false,
      appBindingState: false,
      tree: false,
      proviceList: [],
      cityList: [],
      proviceCoopList: [],
      openType: '',
      filterText: '',
      cityForm: {
        id: '',
        provinceCooperatorId: '',
        cityListVal: []
      },
      loginFlagStatus: true,
      appForm: {
        id: '',
        appUserPhone: ''
      },
      form: {
        id: '',
        provinceCooperatorName: '',
        provinceCooperatorId: '',
        companyName: '',
        companyCode: '',
        cooperatorName: '',
        phone: '',
        password: '',
        age: '',
        sex: '',
        loginFlag: '',
        remarks: ''
      },
      searchForm: {
        phone: '',
        cooperatorName: ''
      },
      rules: {
        cooperatorName: [
          { required: true, message: '请输入合作商姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入合作商电话', trigger: 'blur' }
        ],
        age: [
          { required: true, message: '请输入合作商年龄', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    // 关闭绑定app弹窗时清空
    closeAppFormDialog () {
      this.appForm = {
        id: '',
        appUserPhone: ''
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 选择上级省合作商
    selectMenu (e) {
      this.tree = false
      this.form.provinceCooperatorName = e.target.parentElement.name
      this.form.provinceCooperatorId = e.target.parentElement.value
    },
    // 选择行政区
    cityChange (e) {
      this.cityForm.cityListVal = e
    },
    // 提交服务地区
    submitCity () {
      let _this = this
      _this.formLoading = true
      this.$axios.post('/cooperator/saveCity', _this.cityForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.openCityState = false
            _this.formLoading = false
            _this.listData()
          } else {
            _this.$message.error(res.msg)
            _this.formLoading = false
          }
        })
    },
    // 提交绑定app用户
    submitUserPhone () {
      let _this = this
      if (_this.appForm.appUserPhone.length !== 11) {
        _this.$message.error('请输入11位手机号')
        return
      }
      _this.formLoading = true
      this.$axios.post('/cooperator/saveCityUserPhone', _this.appForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.appBindingState = false
          } else {
            _this.$message.error(res.msg)
          }
          _this.formLoading = false
        })
    },
    closeCityDialog () {
      this.cityForm = {
        id: '',
        provinceCooperatorId: '',
        cityListVal: []
      }
    },
    // 重置搜索
    resetForm () {
      this.searchForm = {
        phone: '',
        cooperatorName: ''
      }
      this.listData()
    },
    closeDialog () {
      this.form = {
        id: '',
        provinceCooperatorName: '',
        provinceCooperatorId: '',
        companyName: '',
        companyCode: '',
        cooperatorName: '',
        phone: '',
        password: '',
        age: '',
        sex: '',
        loginFlag: '',
        remarks: ''
      }
      this.openText = '新增'
    },
    // 打开新增合作商
    openPopup (type) {
      this.openType = type
      this.openState = true
    },
    // 保存合作商
    submit () {
      let _this = this
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(_this.form.phone)) {
        this.$message.error('请输入有效的手机号码')
        return
      }
      if (_this.openType === 'add' && _this.form.password.length < 6) {
        this.$message.error('请输入不小于6位数密码')
        return
      }
      _this.form.loginFlag = _this.loginFlagStatus ? '1' : '0'
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/cooperator/saveCooperator', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.openState = false
                _this.formLoading = false
                _this.listData()
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    // 打开绑定app
    openAppBinding (id) {
      this.appForm.id = id
      this.appBindingState = true
    },
    // 编辑服务地区
    openCity (row) {
      let _this = this
      _this.openCityState = true
      this.$axios.post('/cooperator/getCity', {coopId: row.id})
        .then((res) => {
          if (res.status === 200) {
            let arr = []
            if (res.data !== null && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                arr.push(res.data[i].cityCountyId)
              }
            }
            _this.cityForm = {
              id: row.id,
              provinceCooperatorId: row.provinceCooperatorId,
              cityListVal: arr
            }
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 编辑合作商信息
    openForm (row) {
      console.log(row)
      this.openType = 'edit'
      this.openText = '编辑'
      this.openState = true
      this.form = JSON.parse(JSON.stringify(row))
      this.form = {
        id: row.id,
        provinceCooperatorName: row.provinceCooperatorName,
        provinceCooperatorId: row.provinceCooperatorId,
        companyName: row.companyName,
        companyCode: row.companyCode,
        cooperatorName: row.cooperatorName,
        phone: row.phone,
        password: row.password,
        age: row.age,
        sex: row.sex,
        loginFlag: row.loginFlag,
        remarks: row.remarks
      }
      // 渲染父级标题
      for (let i = 0; i < this.proviceCoopList.length; i++) {
        if (this.proviceCoopList[i].id === this.form.provinceCooperatorId) {
          this.form.provinceCooperatorName = this.proviceCoopList[i].label
          break
        }
      }
      this.formLoading = false
    },
    // 市级行政区选项
    cityOptData () {
      this.$axios.post('/dropDownList/cityList')
        .then((res) => {
          this.cityList = res.data
        })
    },
    // 省级上级选项
    provinceOptData () {
      this.$axios.post('/dropDownList/proviceCoopList')
        .then((res) => {
          this.proviceCoopList = res.data
        })
    },
    // 市级列表
    listData () {
      let _this = this
      _this.isLoading = true
      _this.list = []
      this.$axios.post('/cooperator/list', _this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
    this.provinceOptData()
    this.cityOptData()
  }
}
</script>

<style>
.el-select-dropdown__wrap {
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Cooperator.vue